import React from 'react'
import { DropdownInput, DropdownWithSearch, MultiSelectDropdown } from '../../Inputs';
import { dropDownListObject, multiSelectOption } from '../../Utils/contructObject';
import { getCommonParams } from '../../Utils/helper';
import { useGetArticleQuery } from '../../redux/ErpServices/ArticleService';

const ArticleDropdown = ({ multiSelect = true, withoutLabel = true, readOnly, name, selected, setSelected, selectedType, clear, withSearch }) => {
    const { token, ...params } = getCommonParams();
    const { data: articleList } = useGetArticleQuery({ params: { ...params, selectedType } });

    if (withSearch)
        return (
            <div className='text-xs'>
                <label htmlFor="" >{name}</label>
                <DropdownWithSearch
                    value={selected}
                    setValue={(val) => setSelected(val)}
                    options={articleList?.data || []}
                    required
                    readOnly={readOnly} />
            </div>
        )
    return (
        <>
            {withoutLabel ?
                <select value={selected} onChange={(e) => setSelected(e.target.value)} className='w-full table-data-input'>
                    <option value="">Select</option>
                    {(articleList ? articleList.data : []).map(item =>
                        <option key={item.id} value={item.id}>{item.name}</option>
                    )}
                </select>
                :
                <>
                    {multiSelect ?
                        <MultiSelectDropdown readOnly={readOnly} name={name} selected={selected} setSelected={setSelected}
                            options={multiSelectOption(articleList?.data ? articleList.data : [], "name", "id")} />
                        :
                        <DropdownInput readOnly={readOnly} name={name} value={selected} setValue={setSelected} clear={clear}
                            options={dropDownListObject(articleList?.data ? articleList.data : [], "name", "id")} />
                    }
                </>
            }
        </>
    )
}

export default ArticleDropdown
